import React from 'react';
import Navbar from '../components/Navbar';
import StaffingHero from '../components/staffing/StaffingHero';
import IndustryProblem from '../components/staffing/IndustryProblem';
import WhyTraainStaffing from '../components/staffing/WhyTraainStaffing';
import TrainingIntelligencePillar from '../components/staffing/TrainingIntelligencePillar';
import RolePlayIntelligencePillar from '../components/staffing/RolePlayIntelligencePillar';
import StaffingKPIs from '../components/staffing/StaffingKPIs';
import StaffingCTA from '../components/staffing/StaffingCTA';
import Footer from '../components/Footer';

const StaffingRecruitingPage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-950 via-gray-900 to-indigo-950 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <StaffingHero />
        <IndustryProblem />
        <WhyTraainStaffing />
        <TrainingIntelligencePillar />
        <RolePlayIntelligencePillar />
        <StaffingKPIs />
        <StaffingCTA />
        <Footer />
      </div>
    </div>
  );
};

export default StaffingRecruitingPage;
